import Phaser from 'phaser';
import { knock } from './effects';

export default class Door extends Phaser.GameObjects.Sprite {
  constructor(scene, x, y) {
    super(scene, x, y, 'door');

    this.setOrigin(0.5, 1);
    this.setScale(0.8);

    this.scene.add.existing(this);
  }

  open(fantasy = false) {
    this.setTexture(fantasy ? 'door_open_fantasy' : 'door_open');
  }

  knock() {
    knock.call(this.scene);
  }

  close() {
    this.setTexture('door');
    // this.scene.tweens.add({

    // });
  }
}

export function preload() {
  this.load.image('door', `ornaments/door.png`);
  this.load.image('door_open', 'ornaments/door_open.png');
  this.load.image('door_open_fantasy', 'ornaments/door_open_fantasy.png');
}
